import Button from '@jetbrains/ring-ui/components/button/button'
import {useMemo} from 'react'

import type {BuildId} from '../../../../../../../types'
import SvgIcon from '../../../../../../common/SvgIcon/SvgIcon'
import DownloadBuildLog from '../../../../DownloadBuildLog/DownloadBuildLog'

import styles from './DownloadBuildLogDropdown.css'

type Props = {
  className?: string
  buildId: BuildId
}

function DownloadBuildLogDropdown({className, buildId}: Props) {
  const anchor = useMemo(
    () => (
      <Button dropdown>
        <SvgIcon icon="download" className={styles.icon} />
        {'Download log '}
      </Button>
    ),
    [],
  )

  return <DownloadBuildLog className={className} buildId={buildId} anchor={anchor} />
}

export default DownloadBuildLogDropdown
